import { Button } from '@evaneos/b2b-ui/legacy';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import windRose from '../../../assets/wind_rose.svg';

import s from '../MessageTemplates.module.css';

export const NoMessageTemplates = (): JSX.Element => (
    <div className={s.emptyTemplates} data-testid="message-template-empty">
        <div>
            <img className={s.windRose} src={windRose} alt="" />
            <div className={s.explanations}>
                <h2>
                    <FormattedMessage id="templates.empty.title" />
                </h2>
                <p className="body ink-light">
                    <FormattedMessage id="templates.empty.tip" />
                </p>
            </div>
        </div>
        <Link to={{ pathname: '/templates/new' }}>
            <Button>
                <FormattedMessage id="templates.empty.new" />
            </Button>
        </Link>
    </div>
);
